export default {
  getTerms: (state) => state.terms
};
